module.exports = __webpack_public_path__ + "img/password2.b251e038.png";